import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { IMoveMoneyLimits } from './getWireLimits';
import { endpointManager } from '../../../services/endpoint.service';

interface IProps {
  queryKey?: string;
}

export const getAchOutLimits = (
  { queryKey }: IProps,
  onError: (errData: { errCode: number; errMsg: string }) => void,
) => {
  const { getAchOutLimitsUrl } = endpointManager();
  return useQuery(
    queryKey || 'ach-out-limits',
    async (): Promise<IMoveMoneyLimits> => {
      const { data } = await httpService.get(
        getAchOutLimitsUrl(),
      );
      return data;
    },
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onError: (_e: IServerErrorResponse) => {
        const errData = _e?.response?.data?.errors?.[0];
        const errCode = errData?.code;
        const errMsg = errData?.localizedMessage;
        trackMixPanel('View ACH to 3rd Party - Error Occurred', {
          errorCode: errCode,
          errorMessage: errMsg,
        });
        onError({ errCode, errMsg });
      },
    },
  );
};
